module.exports = __webpack_public_path__ + "img/ukasko-dgo-logo.d2254b77.svg";